import QuantityEditingContent from './QuantityEditingContent';

export default QuantityEditingContent;
